import { DISTRIBUTOR_NAME } from '@autopass-web/domain';
import analyticsLoggerImpl from '@autopass-web/mochi-analytics';

import { ENV_CONFIG } from '../config';
import { DIST } from '../config';
import storage from './storage';

class Analytics {
  init = () => {
    analyticsLoggerImpl.init(ENV_CONFIG.AMPLITUDE_KEY);
  };

  track = (name, properties = {}) => {
    if (!analyticsLoggerImpl.getUserId()) {
      analyticsLoggerImpl.setUserId(storage.getUser()?.id);
    }
    properties['distributor'] = DISTRIBUTOR_NAME[DIST];
    analyticsLoggerImpl.log(name, properties);
  };

  splash = () =>
    this.track('splash', {
      'user-Agent': window.navigator.userAgent,
    });

  //通用
  ads_onClick = (id) => this.track('廣告_click', { id });

  // Welcome
  tutorial_scroll = (page) =>
    this.track('tutorial_scroll', {
      slide: page,
    });
  tutorial_pageview = () => this.track('tutorial_pageview');
  tutorial_later_onClick = () => this.track('tutorial_稍後_click');
  tutorial_start_onClick = () => this.track('tutorial_立即開始_click');

  // 登入
  login_pageview = () => this.track('連結帳戶_登入_pageview');
  login_mobile_onClick = () => this.track('連結帳戶_輸入手機_click');
  login_sendOtp_onClick = () => this.track('連結帳戶_傳送驗證碼_click');
  login_otp_onClick = () => this.track('連結帳戶_輸入驗證碼_click');
  login_button_onClick = () => this.track('連結帳戶_登入/註冊_click');

  // 註冊
  register_pageview = () => this.track('連結帳戶_註冊_pageview');
  register_email_onClick = () => this.track('連結帳戶_輸入電子信箱_click');
  register_button_onClick = () => this.track('連結帳戶_完成註冊_click');

  // 路停自動繳 on boarding
  onStreetParkingAutoPay_pageview = () =>
    this.track('路停自動繳OB_立即啟用自動繳_pageview');
  onStreetParkingAutoPay_start_onClick = () =>
    this.track('路停自動繳OB_立即啟用_click');
  onStreetParkingAutoPay_later_onClick = () =>
    this.track('路停自動繳OB_稍後_click');
  onStreetParkingAutoPay_dialog_onOpen = () =>
    this.track('路停自動繳OB_dialog_open');
  onStreetParkingAutoPay_dialog_enable_onClick = () =>
    this.track('路停自動繳OB_dialog_啟用自動繳_click');
  onStreetParkingAutoPay_dialog_pass_onClick = () =>
    this.track('路停自動繳OB_dialog_先不啟用_click');

  // 加入付款車牌
  addPlateNumber_pageview = () => this.track('路停自動繳OB_加入車牌_pageview');
  addPlateNumber_plateNumber_onClick = () =>
    this.track('路停自動繳OB_輸入車牌_click');
  addPlateNumber_vehicleType_onClick = (type) =>
    this.track('路停自動繳OB_選擇車種_click', { 車種: type });
  addPlateNumber_button_onClick = ({ plateNumber, type }) =>
    this.track('路停自動繳OB_設定好了_click', {
      車牌: plateNumber,
      車種: type,
    });
  addPlateNumber_later_onClick = () =>
    this.track('路停自動繳OB_稍後輸入車牌_click');
  addPlateNumber_rental_dialog_pageView = () =>
    this.track('路停自動繳OB_租賃車提示dialog_pageview');
  addPlateNumber_rental_dialog_confirm_onClick = () =>
    this.track('路停自動繳OB_租賃車提示dialog_知道了_Click');
  activated_confirm_onClick = () =>
    this.track('路停自動繳OB_車牌頁_確定啟用_click');
  activated_dialog_pageview = () =>
    this.track('路停自動繳OB_車牌頁_選擇車牌彈窗_pageview');
  activated_dialog_back_onClick = () =>
    this.track('路停自動繳OB_車牌頁_選擇車牌彈窗_返回_click');

  // 連結付款
  bindCard_pageView = () => this.track('路停自動繳OB_綁定信用卡_pageview');
  bindCard_ccNumber_onClick = () => this.track('路停自動繳OB_輸入卡號_click');
  bindCard_ccExpireDate_onClick = () =>
    this.track('路停自動繳OB_輸入到期日_click');
  bindCard_ccCVC_onClick = () => this.track('路停自動繳OB_輸入CVC_click');
  bindCard_button_onClick = () => this.track('路停自動繳OB_開始綁定_click');
  bindCard_later_onClick = () => this.track('路停自動繳OB_稍後綁定_click');
  // npc
  bindNpcPay_switchRedeemUse_onClick = ({ type }) =>
    this.track('路停自動繳OB_付款頁_連結通路 payment_外部點數折抵開關', {
      type,
    });
  // cpc
  bindCpcpay_pageview = () => this.track('路停自動繳OB_綁定中油卡_pageview');
  bindCpcpay_button_onClick = () => this.track('路停自動繳OB_確認連結_click');
  bindCpcpay_later_onClick = () =>
    this.track('路停自動繳OB_稍後確認連結_click');

  // 提醒查詢路停單
  onStreetParkingAutoPayNotice_pageview = ({ page }) =>
    this.track('路停自動繳-使用前提醒-dialog_pageview', {
      'dialog 顯示來源': page,
    });
  onStreetParkingAutoPayNotice_onClick = ({ action, page }) =>
    this.track('路停自動繳-使用前提醒-dialog_點擊', {
      動作: action,
      'dialog 顯示來源': page,
    });

  // 主頁
  main_pageview = () => this.track('行動錢包_pageview');
  main_login_onClick = () => this.track('行動錢包_未登入_登入麻吉付_click');
  main_set_mochipay_onClick = () =>
    this.track('行動錢包_已登入_設定麻吉付_Click');
  main_setting_onClick = () => this.track('行動錢包_齒輪_click');
  main_ads_onClick = (id) => this.track('行動錢包_廣告_click', { id });
  main_notification_onClick = (id) =>
    this.track('行動錢包_異常公告_click', { id });
  main_refueling_onClick = () =>
    this.track('行動錢包_我要加油_click', { 入口: '主頁' });
  main_parking_onClick = () => this.track('行動錢包_我要停車_click');
  main_onStreetParking_onClick = () => this.track('行動錢包_路停停車_click');
  main_plateNumber_onClick = () => this.track('行動錢包_列表_付款車牌_click');
  main_payment_onClick = () => this.track('行動錢包_列表_付款方式_click');
  main_receipt_onClick = () => this.track('行動錢包_列表_發票設定_click');
  main_points_onClick = () => this.track('行動錢包_列表_點數折抵_click');
  main_orders_onClick = () => this.track('行動錢包_列表_消費紀錄_click');
  main_coupon_onClick = () => this.track('行動錢包_列表_優惠券_click');
  main_promotions_onClick = () => this.track('行動錢包_列表_付款優惠_click');
  main_shortcut_onClick = () =>
    this.track('行動錢包_列表_儲存網頁 App 捷徑_click');
  main_contact_onClick = () => this.track('行動錢包_列表_聯繫客服_click');
  main_point_redeem_external_point_on_onClick = () =>
    this.track('行動錢包_列表_點數扣抵_外部點數開關_開');
  main_point_redeem_external_point_off_onClick = () =>
    this.track('行動錢包_列表_點數扣抵_外部點數開關_關');
  main_parking_navigation_onClick = () =>
    this.track('行動錢包_停車中_導航_click');
  main_parking_help_onClick = () => this.track('行動錢包_停車中_幫助_click');
  main_parking_help_paid_onClick = () =>
    this.track('停車中_幫助_我已繳費離場_click');
  main_parking_help_notParking_onClick = () =>
    this.track('停車中_幫助_我沒有去停車_click');
  main_parking_help_more_onClick = () =>
    this.track('停車中_幫助_進一步協助_click');
  main_parking_help_cancel_onClick = () => this.track('停車中_幫助_取消_click');
  finish_both_setting_pageview = ({ entry }) =>
    this.track('完成付款與車牌設定-actiondialog_pageview', { 入口: entry });
  finish_both_setting_onClick = ({ action }) =>
    this.track('完成付款與車牌設定-actiondialog_點擊', { 動作: action });
  finish_payment_setting_pageview = ({ entry }) =>
    this.track('完成付款設定-actiondialog_pageview', { 入口: entry });
  finish_payment_setting_onClick = ({ action }) =>
    this.track('完成付款設定-actiondialog_點擊', { 動作: action });
  finish_payment_success_setting_pageview = ({ entry }) =>
    this.track('條碼付-重新設定付款方式-actiondialog_pageview', {
      入口: entry,
    });
  finish_payment_success_setting_onClick = ({ action }) => {
    this.track('條碼付_重新設定付款方式-actiondialog_點擊', { 動作: action });
  };
  finish_licensePlate_setting_pageview = ({ entry }) =>
    this.track('完成車牌設定-actiondialog_pageview', { 入口: entry });
  finish_licensePlate_setting_onClick = ({ action }) =>
    this.track('完成車牌設定-actiondialog_點擊', { 動作: action });

  // 設定頁
  setting_pageview = () => this.track('會員設定頁_pageview');
  setting_profile_onClick = () => this.track('會員設定頁_個人資料_click');
  setting_terms_onClick = () => this.track('會員設定頁_麻吉付服務條款_click');
  setting_logout_onClick = () => this.track('會員設定頁_登出_click');

  // 捷徑教學頁
  shortcut_pageview = () => this.track('捷徑教學頁_pageview');
  shortcut_back_onClick = () => this.track('捷徑教學頁_返回_Click');
  shortcut_iphone_onClick = () => this.track('捷徑教學頁_iPhone_Click');
  shortcut_android_onClick = () => this.track('捷徑教學頁_Android_Click');

  // 加油要求
  refueling_request_pageview = () => this.track('加油授權_加油視窗_pageview');
  accept_refueling_request = () => this.track('加油授權_同意付款_Click');
  cancel_refueling_request = () => this.track('加油授權_關閉視窗_Click');

  // 路停自動繳
  onStreetParking_pageview = ({ state, failedReason }) =>
    this.track('開啟路停頁_pageview', {
      自動繳費啟用狀態: state,
      異常原因: failedReason,
    });
  onStreetParking_enable_onClick = ({ state, failedReason }) =>
    this.track('開啟路停頁_開啟_Click', {
      自動繳費啟用狀態: state,
      異常原因: failedReason,
    });
  onStreetParking_disable_onClick = ({ state, failedReason }) =>
    this.track('開啟路停頁_關閉_Click', {
      自動繳費啟用狀態: state,
      異常原因: failedReason,
    });

  onStreetParking_inquire_onClick = () =>
    this.track('開啟路停頁_查詢繳費_Click');
  onStreetParking_inquire_complete_onClick = () =>
    this.track('開啟路停頁_查詢繳費_完成_Click');
  onStreetParking_help_onClick = ({ state, failedReason }) =>
    this.track('開啟路停頁_常見問題_Click', {
      自動繳費啟用狀態: state,
      異常原因: failedReason,
    });
  onStreetParking_bindingFailed_onClick = () =>
    this.track('開啟路停頁_綁定失敗_點擊');

  // 車牌設定頁
  plateNumber_pageview = ({
    failedReason,
    onStreetParkingFailedLicensePlates,
    taipeiParkingFailedLicensePlates,
  }) =>
    this.track('車牌頁_pageview', {
      異常原因: failedReason,
      路停自動繳綁定失敗的車牌: onStreetParkingFailedLicensePlates,
      北市公有停車綁定失敗: taipeiParkingFailedLicensePlates,
    });
  plateNumber_plate_onClick = () => this.track('車牌頁_車牌_Click');
  plateNumber_add_onClick = () => this.track('車牌頁_新增_Click');
  plateNumber_activate_onClick = () => this.track('車牌頁_啟用_Click');

  plateNumber_add_pageView = () => this.track('車牌頁_新增車牌頁_pageview');

  plateNumber_add_contact_onClick = ({ action }) =>
    this.track('車牌頁-新增車牌頁-聯繫客服_點擊', {
      動作: action,
    });

  plateNumber_add_plate_onClick = () =>
    this.track('車牌頁_新增_輸入車牌_Click');
  plateNumber_add_type_onClick = (type) =>
    this.track('車牌頁_新增_選擇車種_Click', { type });
  plateNumber_add_energySource_Select = (energySource) =>
    this.track('車牌頁_新增_選擇動力類型_Select', {
      energy_source: energySource,
    });
  plateNumber_add_type_info_click = () =>
    this.track('車牌頁_新增_選擇車種_info_click');

  plateNumber_edit_type_info_click = () =>
    this.track('車牌頁_修改_選擇車種_info_click');

  plateNumber_add_complete_onClick = () =>
    this.track('車牌頁_新增_設定好了_Click');
  plateNumber_add_confirmDialog_pageView = () =>
    this.track('車牌頁-新增-確認車牌號碼與車種dialog_pageview');
  plateNumber_add_confirmDialog_confirm_onClick = () =>
    this.track('車牌頁-新增-確認車牌號碼與車種_確認_Click');
  plateNumber_add_confirmDialog_cancel_onClick = () =>
    this.track('車牌頁-新增-確認車牌號碼與車種_取消_Click');

  plateNumber_window_myMochipass_onClick = () =>
    this.track('車牌頁_編輯視窗_管理快速通_Click');
  plateNumber_window_onStreetParkingBindingFailed_onClick = () =>
    this.track('車牌頁_編輯視窗_路停自動繳失敗重綁_Click');
  plateNumber_window_rebind_onClick = () =>
    this.track('車牌頁_編輯視窗_北市公有停車失敗重綁_Click');
  plateNumber_window_edit_onClick = () =>
    this.track('車牌頁_編輯視窗_修改車牌_Click');
  plateNumber_window_delete_onClick = () =>
    this.track('車牌頁_編輯視窗_刪除車牌_Click');
  plateNumber_window_cancel_onClick = () =>
    this.track('車牌頁_編輯視窗_取消_Click');

  plateNumber_edit_pageView = () => this.track('車牌頁_修改車種_pageview');
  plateNumber_edit_type_onClick = (type) =>
    this.track('車牌頁_修改_選擇車種_Click', { type });
  plateNumber_edit_energy_onClick = (energySource) =>
    this.track('車牌頁_修改_選擇動力類型_Select', { energySource });
  plateNumber_edit_complete_onClick = () =>
    this.track('車牌頁_修改_設定好了_Click');
  plateNumber_edit_confirmDialog_pageView = () =>
    this.track('車牌頁-修改-修改車種dialog_pageview');
  plateNumber_edit_confirmDialog_confirm_onClick = () =>
    this.track('車牌頁-修改-修改車種dialog_確認_Click');
  plateNumber_edit_confirmDialog_cancel_onClick = () =>
    this.track('車牌頁-修改-修改車種dialog_取消_Click');

  plateNumber_rental_dialog_pageView = () =>
    this.track('車牌頁_租賃車提示dialog_pageview');
  plateNumber_rental_dialog_confirm_onClick = () =>
    this.track('車牌頁_租賃車提示dialog_知道了_Click');
  plateNumber_cross_dist_dialog_pageView = () =>
    this.track('車牌頁_尚綁定在其他服務dialog_pageview');
  plateNumber_cross_dist_dialog_confirm_onClick = () =>
    this.track('車牌頁_尚綁定在其他服務dialog_知道了_Click');
  plateNumber_delete_dialog_normal_pageView = () =>
    this.track('車牌頁-刪除車牌-一般刪除車牌dialog_pageview');
  plateNUmber_delete_dialog_normal_confirm_onClick = () =>
    this.track('車牌頁-刪除車牌-一般刪除車牌_確認_Click');
  plateNumber_delete_dialog_normal_cancel_onClick = () =>
    this.track('車牌頁-刪除車牌-一般刪除車牌_取消_Click');
  plateNumber_delete_dialog_pass_pageView = () =>
    this.track('車牌頁-刪除車牌-快速通刪除車牌dialog_pageview');
  plateNUmber_delete_dialog_pass_confirm_onClick = () =>
    this.track('車牌頁-刪除車牌-快速通刪除車牌_確認_Click');
  plateNumber_delete_dialog_pass_cancel_onClick = () =>
    this.track('車牌頁-刪除車牌-快速通刪除車牌_取消_Click');
  plateNumber_delete_dialog_parking_pageView = () =>
    this.track('車牌頁-刪除車牌-停車中刪除車牌dialog_pageview');
  plateNUmber_delete_dialog_parking_onClick = () =>
    this.track('車牌頁-刪除車牌-停車中刪除車牌_知道了_Click');

  // 付款頁
  payment_addCard_onClick = () => this.track('付款頁_新增_Click');
  payment_addCard_cardNumber_onClick = () =>
    this.track('付款頁_新增_卡號_Click');
  payment_addCard_expireDate_onClick = () =>
    this.track('付款頁_新增_有效期限_Click');
  payment_addCard_cvc_onClick = () => this.track('付款頁_新增_安全碼_Click');
  payment_addCard_confirm_onClick = () =>
    this.track('付款頁_新增_設定好了_Click');
  payment_setting_reset_onClick = () =>
    this.track('付款頁_齒輪_重新設定_Click');
  payment_setting_delete_onClick = () => this.track('付款頁_齒輪_刪除_Click');
  payment_setting_cancel_onClick = () => this.track('付款頁_齒輪_取消_Click');
  payment_setting_delete_confirm_onClick = () =>
    this.track('付款頁_齒輪_刪除_確認_Click');
  payment_setting_delete_cancel_onClick = () =>
    this.track('付款頁_齒輪_刪除_取消_Click');
  payment_bindCard_onClick = () => this.track('付款頁_綁定中油pay_Click');
  payment_bindCard_onCancel = () =>
    this.track('付款頁_綁定中油pay_解除綁定_Click'); //deprecate
  payment_bindCard_confirm_onClick = () =>
    this.track('付款頁_綁定中油pay_確認綁定_Click'); // deprecate
  payment_bindCard_cancel_onClick = () =>
    this.track('付款頁_綁定中油pay_取消_Click');
  payment_linkCard_onClick = (cardType) =>
    this.track('付款頁_連結通路 payment_Click', { cardType });
  payment_switchRedeemUse_onClick = ({ type }) =>
    this.track('付款頁_連結通路 payment_外部點數折抵開關', { type });
  payment_linkCard_confirm_onClick = () =>
    this.track('付款頁_連結通路 payment_確認連結_Click');
  payment_linkCard_dialog_unlink_onClick = () =>
    this.track('付款頁_連結通路 payment_彈窗_斷連_Click');
  payment_linkCard_dialog_cancel_onClick = () =>
    this.track('付款頁_連結通路 payment_彈窗_取消_Click');

  payment_freeParkingToggle_onClick = ({ isOpen }) =>
    this.track('付款頁_免停自動折開關', {
      動作: isOpen ? '開啟' : '關閉',
    });

  payment_freeParkingInstruction_open_onClick = () =>
    this.track('付款頁_免停自動折說明_開啟_Click');
  payment_freeParkingInstruction_close_onClick = () =>
    this.track('付款頁_免停自動折說明_關閉_Click');

  // 教學頁
  services_pageview = (name) => this.track(`${name}說明頁_pageview`);
  services_tutorial_swipe = (name, slide, type) =>
    this.track(`${name}說明頁_教學`, { slide, 類型: type });
  services_settings_onClick = (setting, name, poi) => {
    switch (setting) {
      case 'pass':
        return this.track(`${name}說明頁_快速通設定_Click`);
      case 'plate':
        return this.track(`${name}說明頁_車牌設定_Click`);
      case 'payment':
        return this.track(`${name}說明頁_付款設定_Click`);
      case 'support':
        return this.track(`${name}說明頁_支援${poi}_Click`);
      case 'navigate':
        return this.track(`${name}說明頁_前往場站_Click`);
      default:
        return '';
    }
  };
  services_refueling_selector_onClick = (type) =>
    this.track(`加油說明頁-分頁按鈕_Click`, { 類型: type });
  services_refueling_hint_onClick = () =>
    this.track(`加油說明頁_支援付款方式_Click`);
  services_refueling_hint_dialog_pageview = () =>
    this.track(`加油說明頁_支援付款方式 dialog_pageview`);

  // 底部 navbar
  tab_main_onClick = () => this.track('Tab_行動錢包_Click');
  tab_maps_onClick = () => this.track('Tab_支援場站_Click');
  tab_orders_onClick = () => this.track('Tab_消費紀錄_Click');
  tab_coins_onClick = () => this.track('Tab_行車幣_Click');

  //  行車幣
  coins_pageview = () => this.track('行車幣_pageview');
  coins_enabled_onClick = () => this.track('行車幣_獲得_Click');
  coins_enabled_pageview = () => this.track('行車幣_獲得_pageview');
  coins_disabled_onClick = () => this.track('行車幣_已使用_Click');
  coins_disabled_pageview = () => this.track('行車幣_已使用_pageview');
  coins_help_onClick = () => this.track('行車幣_幫助_Click');

  // 消費紀錄
  orders_tab_onClick = ({ transactionType }) =>
    this.track('消費紀錄頁_交易類型_頁籤', { transactionType });

  // 條碼付款
  barcode_payment_entry_onClick = ({ entry }) =>
    this.track('條碼頁-入口按鈕_點擊', { 入口: entry });
  barcode_payment_support_onClick = () => this.track('條碼頁-支援場站_點擊');
  barcode_payment_leave = ({ action }) =>
    this.track('條碼頁_離開', { 觸發離開動作: action });

  // 停車紀錄
  parking_records_navigation_onClick = () => this.track('停車紀錄_導航_click');
  parking_records_help_onClick = () => this.track('停車紀錄_幫助_click');
  parking_records_help_paid_onClick = () =>
    this.track('停車紀錄_幫助_我已繳費離場_click');
  parking_records_help_notParking_onClick = () =>
    this.track('停車紀錄_幫助_我沒有去停車_click');
  parking_records_help_cancel_onClick = () =>
    this.track('停車紀錄_幫助_取消_click');

  // 停車說明頁
  parking_detail_pageview = () => this.track('停車說明頁_pageview');

  // 地圖
  map_CTAButton_click = () => this.track('麻吉地圖_CTA按鈕_點擊');

  // PLUS Pay onboarding
  plusPay_welcome_confirm_buttonClick = () =>
    this.track('顯示授權資訊頁OB_確認按紐_Click');

  plusPay_plateNumber_inputFocus = () => {
    this.track('顯示授權資訊頁OB_新增車牌頁_輸入車牌_Click');
  };

  plusPay_addNewPlateNumber_selectVehicleType = ({ type }) =>
    this.track('顯示授權資訊頁OB_新增車牌頁_選擇車種_Click', { 車種: type });

  plusPay_addNewPlateNumber_settle = () =>
    this.track('顯示授權資訊頁OB_新增車牌頁_設定好了_Click');

  plusPay_addNewPlateNumber_back = () =>
    this.track('顯示授權資訊頁OB_新增車牌頁_返回_Click');

  plusPay_bindCard_buttonClick = () =>
    this.track('顯示授權資訊頁OB_授權綁定按鈕_Click');
}

const analytics = new Analytics();

export default analytics;
